import { render, staticRenderFns } from "./payOther.vue?vue&type=template&id=56f92c9a&scoped=true&"
import script from "./payOther.vue?vue&type=script&lang=js&"
export * from "./payOther.vue?vue&type=script&lang=js&"
import style0 from "./payOther.vue?vue&type=style&index=0&id=56f92c9a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f92c9a",
  null
  
)

export default component.exports